import React from "react";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import renderMarkdown from "../markdown";
import copilotStore from "Stores/copilotStore";

// [Name](sg-table:<id>) opens a table the copilot looked up in the background on the right.
const TABLE_LINK = "sg-table:";

const TextBlock = observer(({ block, isStreaming }) => {
  const history = useHistory();

  return (
    <div className="copilotText">
      {renderMarkdown(block.markdown, path =>
        path.startsWith(TABLE_LINK) ? copilotStore.openTablePanel(path.slice(TABLE_LINK.length)) : history.push(path)
      )}
      {isStreaming && <span className="copilotText__cursor" />}
    </div>
  );
});

export default TextBlock;
